import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { AvGroup, AvInput, AvForm, AvFeedback } from 'availity-mobx-reactstrap-validation';
import { Label } from 'reactstrap';

import EditTokenFormState from 'js/stores/forms/EditTokenFormState';

import ErrorDisplay from 'js/components/common/ErrorDisplay';
import Button from 'js/components/common/Button';

import SubmitRow from 'js/components/core/Modal/SubmitRow';

import Container from './Container';
import Title from './Title';
import { getSnapshot } from 'mobx-state-tree';

@inject('page')
@observer
export default class EditToken extends Component {
  editToken = EditTokenFormState.create(getSnapshot(this.props.page));

  saveToken = () => !this.editToken.requestInProgress && this.editToken.save().then(this.props.page.tokenSaved);

  render() {
    const editToken = this.editToken;
    return (
      <Container>
        <Title>Edit offer</Title>

        <AvForm onValidSubmit={this.saveToken}>
          <AvGroup>
            <Label for="title">Title</Label>
            <AvInput name="title" id="title" onChange={editToken.setTitle} value={editToken.title} required />
            <AvFeedback>Please enter a title for the item</AvFeedback>
          </AvGroup>

          <AvGroup>
            <Label for="price">Price</Label>
            <AvInput name="price" id="price" onChange={editToken.setPrice} value={editToken.price} required />
            <AvFeedback>Please enter a price for the item</AvFeedback>
          </AvGroup>

          <ErrorDisplay>{editToken.error}</ErrorDisplay>

          <SubmitRow>
            <Button type="submit" isLoading={editToken.requestInProgress}>
              Save
            </Button>
          </SubmitRow>
        </AvForm>
      </Container>
    );
  }
}
